export default __webpack_public_path__ + "58b668dcb9431c368b854b5379453773.svg";